function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.732 12c-.77 1.333-2.694 1.333-3.464 0L1.072 3c-.77-1.333.192-3 1.732-3h10.392c1.54 0 2.502 1.667 1.732 3l-5.196 9z",
  fill: "#343A40"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none"
  }, props), _ref);
};

export default SvgComponent;